module.exports = __webpack_public_path__ + "static/media/gold-rush.8d51c5d2.gif";